import {
  CHAMBER_ACTIVATE,
  CHAMBER_DEACTIVATE,
  CHAMBER_SET_SELECTED,
  CHAMBER_RESET_SELECTED,
  CHAMBER_CONTEXT_SELECTED,
  CHAMBERS_ACTIVATE,
  CHAMBERS_DEACTIVATE,
  CHAMBERS_META_UPDATE,
  CHAMBERS_META_CLEAN,
  CHAMBERS_ISOLATOR_CLEAN,
  CHAMBERS_ISOLATOR_UPDATE,
  CHAMBER_SET_KEY_VALUE,
  CHAMBERS_MANIFOLD_VOID_CLEAN,
  CHAMBERS_MANIFOLD_META_UPDATE,
  CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN,
  IS_DIRTY,
  SHOW_INSERTA_TEE_WARNING,
  SHOW_INSERTA_TEE_VALUES,
  SHOW_INSERTA_TEE_WARNING_TYPE,
  IMPERVIOUS_LINER, SHOW_FEED_CONNECTOR_VALUES
} from "../lib/types";
import ManifoldSelectors from '../reducers/main-manifold-reducer';

export const activate = (row, col) => (dispatch, getState) => {
  // Check to ensure we're not violating the separation distance from chamber to structrue
  const manifoldIds = getState()
    .chamberbed.chamberRows[row].chambers.filter(
      (c) =>
        (c.upperCapAccessory && c.upperCapAccessory.manifoldId) ||
        (c.lowerCapAccessory && c.lowerCapAccessory.manifoldId),
    )
    .map((c) => {
      return {
        manifoldId:
          c.upperCapAccessory && c.upperCapAccessory.manifoldId
            ? c.upperCapAccessory.manifoldId
            : c.lowerCapAccessory.manifoldId,
        col: c.col,
      };
    });
  let foundConflict = false;
  manifoldIds.forEach((m) => {
    const manifold = ManifoldSelectors.getManifoldByIdFromMain(m.manifoldId);
    if (
      manifold.chambersInUse &&
      manifold.chambersInUse.voidRows &&
      manifold.chambersInUse.voidRows.find((vr) => vr.row === row && vr.col === col)
    ) {
      foundConflict = true;
    }
  });

  if (!foundConflict) {
    dispatch({
      type: CHAMBER_ACTIVATE,
      payload: {
        row,
        col,
      },
    });
  }
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const activateByArray = (chamberCoordinatesArray) => (dispatch) => {
  dispatch({
    type: CHAMBERS_ACTIVATE,
    payload: { chamberCoordinatesArray },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

/**
 *
 * @param chamberCoordinatesArray { Array<{row: number, col: number}> } - Array of chamber coordinates
 * @param actualRow {number} - coordinates -letRow- of the primary chamber where the manifold resides
 * @param actualCol {number} - coordinates -letColumn- of the primary chamber where the manifold resides
 * @param chamberKeyValues {object} - metadata payload
 * @returns {void}
 */
export const modifyChambersByArray =
  (chamberCoordinatesArray, actualRow, actualCol, chamberKeyValues) => (dispatch) => {
    dispatch({
      type: CHAMBERS_META_CLEAN,
      payload: {
        manifoldId: chamberKeyValues['chamberMeta']['manifoldId'],
        actualRow: actualRow,
        actualCol: actualCol,
      },
    });
    dispatch({
      type: CHAMBERS_META_UPDATE,
      payload: {
        chamberCoordinatesArray,
        actualRow,
        actualCol,
        chamberKeyValues,
      },
    });
    dispatch({
      type: IS_DIRTY,
      payload: true,
    });
  };

export const modifyChambersByManifoldVoidArray =
  (chamberCoordinatesArray, actualRow, actualCol, chamberKeyValues) => (dispatch) => {
    dispatch({
      type: CHAMBERS_MANIFOLD_META_UPDATE,
      payload: {
        chamberCoordinatesArray,
        actualRow,
        actualCol,
        chamberKeyValues,
      },
    });
    dispatch({
      type: IS_DIRTY,
      payload: true,
    });
  };

export const cleanChambersByManifoldVoidArray = (manifoldId, actualRow, actualCol) => (dispatch) => {
  dispatch({
    type: CHAMBERS_MANIFOLD_VOID_CLEAN,
    payload: {
      manifoldId: manifoldId,
      actualRow: actualRow,
      actualCol: actualCol,
    },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const cleanChambersByManifoldMainRowArray = (manifoldId, actualRow, actualCol) => (dispatch) => {
  dispatch({
    type: CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN,
    payload: {
      manifoldId: manifoldId,
      actualRow: actualRow,
      actualCol: actualCol,
    },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const modifyChambersByArrayIsolator =
  (chamberCoordinatesArray, actualRow, actualCol, chamberKeyValues) => (dispatch) => {
    dispatch({
      type: CHAMBERS_ISOLATOR_CLEAN,
      payload: {
        manifoldId: chamberKeyValues.isIsolatorArray.manifoldId,
        actualRow: actualRow,
        actualCol: actualCol,
      },
    });
    dispatch({
      type: CHAMBERS_ISOLATOR_UPDATE,
      payload: {
        chamberCoordinatesArray,
        actualRow,
        actualCol,
        chamberKeyValues,
      },
    });
    dispatch({
      type: IS_DIRTY,
      payload: true,
    });
  };

export const cleanChambersByArrayIsolator = (manifoldId, actualRow, actualCol) => (dispatch) => {
  dispatch({
    type: CHAMBERS_ISOLATOR_CLEAN,
    payload: {
      manifoldId: manifoldId,
      actualRow: actualRow,
      actualCol: actualCol,
    },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const deactivate = (row, col) => (dispatch) => {
  dispatch({
    type: CHAMBER_DEACTIVATE,
    payload: {
      row,
      col,
    },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const deactivateByArray = (chamberCoordinatesArray) => (dispatch) => {
  dispatch({
    type: CHAMBERS_DEACTIVATE,
    payload: { chamberCoordinatesArray },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });
};

export const setSelectedChamber = (row, col) => (dispatch) => {
  dispatch({
    type: CHAMBER_SET_SELECTED,
    payload: {
      row,
      col,
    },
  });
};

export const resetSelectedChamber = () => (dispatch) => {
  dispatch({
    type: CHAMBER_RESET_SELECTED,
  });
};

export const selectChamberContext = (row, col) => (dispatch) => {
  dispatch({
    type: CHAMBER_CONTEXT_SELECTED,
    payload: {
      row,
      col,
    },
  });
};

const getMap = (list) => {
  return list.reduce((map, item) => {
    map.set(item.id, item);

    return map;
  }, new Map());
};

export const getChamberAccessoryMap = () => (dispatch, getState) => {
  const accessories = getState().apptoolbar.accessories;
  return getMap(accessories);
};

/**
 * Will update the key value pair of any property of the chamber based on row col coordinates
 * @param keyValueObject
 * @param row
 * @param col
 * @returns {function(*): void}
 */
export const setChamberKeyValue = (keyValueObject, row, col) => (dispatch) => {
  dispatch({
    type: CHAMBER_SET_KEY_VALUE,
    payload: {
      keyValueObject,
      row,
      col,
    },
  });
};

export const setInsertaTeeWarningType = (value) => (dispatch) => {
  dispatch({
    type: SHOW_INSERTA_TEE_WARNING_TYPE,
    payload: {
      value,
    },
  });
};

export const showInsertaTeeWarning = (value) => (dispatch) => {
  dispatch({
    type: SHOW_INSERTA_TEE_WARNING,
    payload: {
      value,
    },
  });
};

export const setInsertaTeeValues = (row, col, chamberAccessory) => dispatch => {
  dispatch({
    type: SHOW_INSERTA_TEE_VALUES,
    payload: {
      row, col, chamberAccessory
    }
  });
};

export const setImperviousLiner = (value) => dispatch => {
  dispatch({
    type: IMPERVIOUS_LINER,
    payload: value
  });
};

export const setFeedConnectorValues = (row, col, chamberAccessory) => dispatch => {
  dispatch({
    type: SHOW_FEED_CONNECTOR_VALUES,
    payload: {
      row, col, chamberAccessory
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/chamber-actions.js